module.exports = __webpack_public_path__ + "img/log-out-outline.c48f868f.svg";